import { rufe } from './client';

/** SUP-53: offen ist, was bei Google keine Antwort trägt. */
export type Antwortstand = 'offen' | 'beantwortet' | 'alle';

/** SUP-52: der Sendezustand eines Auftrags im Ausgang. */
export type Sendezustand = 'wartend' | 'gesendet' | 'fehlgeschlagen' | 'aufgegeben' | 'ersetzt';

export const SENDEZUSTANDNAME: Readonly<Record<Sendezustand, string>> = {
  wartend: 'wird gesendet',
  gesendet: 'gesendet',
  fehlgeschlagen: 'neuer Versuch folgt',
  aufgegeben: 'nicht gesendet',
  ersetzt: 'ersetzt',
};

/** SUP-52: Google nimmt höchstens 4096 Zeichen — gezählt wie dort, nicht in UTF-16-Einheiten. */
export const ANTWORT_HOECHSTLAENGE = 4096;

export function antwortlaenge(text: string): number {
  return [...text.trim()].length;
}

export type Sendeauftrag = {
  readonly id: string;
  readonly vorgang: 'antwort_setzen' | 'antwort_loeschen';
  readonly antwortText: string | null;
  readonly zustand: Sendezustand;
  readonly versuche: number;
  readonly naechsterVersuch: string | null;
  readonly letzterFehler: string | null;
  readonly angelegtAm: string;
  readonly angelegtVon: string | null;
  readonly gesendetAm: string | null;
};

export type Rezension = {
  readonly id: string;
  readonly standort: string;
  readonly standortBezeichnung: string;
  readonly googleKennung: string;
  readonly sterne: number;
  readonly text: string | null;
  readonly verfasser: string;
  readonly verfasserAnonym: boolean;
  readonly erstelltAm: string;
  readonly geaendertAm: string;
  readonly antwortText: string | null;
  readonly antwortGeaendertAm: string | null;
  readonly aenderungErkanntAm: string | null;
  readonly auftrag: Sendeauftrag | null;
};

export type Standortabgleich = {
  readonly kennung: string;
  readonly bezeichnung: string;
  readonly googleStandort: string | null;
  readonly gelaufenAm: string | null;
  readonly erfolgreichAm: string | null;
  readonly fehler: string | null;
  readonly gesamt: number | null;
  readonly durchschnitt: number | null;
};

/** SUP-55: wogegen die Funktion läuft. */
export type Anbindungsstand = {
  readonly adapter: 'attrappe' | 'google' | 'gesperrt';
  readonly standorte: readonly Standortabgleich[];
};

export type Rezensionsfilter = {
  readonly standort: string | null;
  readonly sterne: readonly number[];
  readonly stand: Antwortstand;
};

export async function rezensionen(
  filter: Rezensionsfilter,
): Promise<{ readonly rezensionen: readonly Rezension[]; readonly gesamt: number }> {
  const abfrage = new URLSearchParams({ stand: filter.stand });
  if (filter.standort !== null) abfrage.set('standort', filter.standort);
  if (filter.sterne.length > 0) abfrage.set('sterne', [...filter.sterne].sort().join(','));
  return rufe(`/rezensionen?${abfrage.toString()}`);
}

export async function anbindung(): Promise<Anbindungsstand> {
  return rufe<Anbindungsstand>('/rezensionen/anbindung');
}

export async function rezension(
  id: string,
): Promise<{ readonly rezension: Rezension; readonly verlauf: readonly Sendeauftrag[] }> {
  return rufe(`/rezensionen/${id}`);
}

export async function antworten(id: string, text: string): Promise<{ readonly auftrag: string }> {
  return rufe(`/rezensionen/${id}/antwort`, { verfahren: 'PUT', rumpf: { text } });
}

export async function antwortLoeschen(id: string): Promise<{ readonly auftrag: string }> {
  return rufe(`/rezensionen/${id}/antwort`, { verfahren: 'DELETE' });
}

export async function erneutSenden(auftrag: string): Promise<void> {
  await rufe(`/rezensionen/auftraege/${auftrag}/erneut`, { verfahren: 'POST' });
}
